import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import ImportTray from '@/assets/icons/import-tray.svg?react';
import { Button } from '@/components/atoms/button';
import { BatchUploadCSVModal } from '@/features/csv/components/BatchUploadCSVModal';
import { ProjectsList } from '@/features/projects/components/ProjectsList';
import { invalidAllProjectQueries } from '@/features/projects/services/project.api';
import { useMixpanel } from '@/hooks/useMixpanel';
import { BUTTON_CLICKED, PAGE_VIEWED } from '@/libs/mixpanel';

export default function DashboardPage() {
  const [uploadModalOpen, setUploadModalOpen] = useState<boolean>(false);
  const queryClient = useQueryClient();

  // Analytics tracking
  const trackPageView = useMixpanel((state) => state.trackPageView);
  const trackButtonClicked = useMixpanel((state) => state.trackButtonClicked);

  // Page view tracking
  useEffect(() => {
    trackPageView(PAGE_VIEWED.DASHBOARD_PAGE);
  }, [trackPageView]);

  return (
    <div className="w-full max-w-full bg-background text-gray-900 py-12 desktop:px-28 laptop:px-8 px-4 mt-14">
      <header className="mb-6 grid grid-cols-[minmax(0,1fr)_auto] items-start gap-x-3 gap-y-2">
        <h1 className="min-w-0 text-2xl font-semibold sm:text-3xl">History</h1>
        <div className="col-start-2 row-start-1 flex shrink-0 items-center gap-2">
          <Button
            size="lg"
            onClick={() => {
              trackButtonClicked(BUTTON_CLICKED.UPLOAD_CSV);
              setUploadModalOpen(true);
            }}
          >
            <ImportTray aria-hidden />
            Import CSV
          </Button>
        </div>
        <p className="col-span-2 hidden text-sm text-muted-foreground sm:col-span-1 sm:block">
          Every batch import and project analysis you've run, most recent first.
        </p>
      </header>
      <ProjectsList />
      <BatchUploadCSVModal
        open={uploadModalOpen}
        setOpen={setUploadModalOpen}
        onProjectCreated={() => {
          invalidAllProjectQueries(queryClient);
        }}
      />
    </div>
  );
}
